<template>
  <div  id="sub_wrap" class="login_wrap">
    <!--content start-->
    <div class="grab" style="text-align: center">
      <a href="index.html">
        <img class="logo_image" src="/static/img/login_logo.png">
      </a>
      <!--<form name="loginForm" method="post" id="loginForm" novalidate="novalidate">-->
        <div class="loginBox">
          <div class="inputWrap">
            <input type="email" class="form-control" tabindex="1" name="email" id="email" placeholder="아이디 입력" v-model="id">
          </div>
          <div class="inputWrap">
            <input type="password" class="form-control" tabindex="2" name="pwd" id="pwd-login" autocapitalize="off"
                   placeholder="비밀번호 입력" v-model="password">
          </div>
          <div class="btnWrap">
            <button v-on:click="login()">{{ $t("login") }}</button>
          </div>
        </div>
      <!--</form>-->
    </div>

    <!--footer start-->
    <footer class="footer login_wrap">
      <div class="grab">
        <div class="footer_txt">
          <address class="address">(34055) 경기도 성남시 분당구 느티로 16 젤존타워1
            &nbsp;&nbsp;&nbsp;전화: 070-4366-0983,&nbsp;&nbsp;&nbsp; 팩스: 070-4366-0983</address>
          <p class="copyright">Copyright (C) Renasoftware. All Rights Reserved.</p>
        </div>

      </div>
    </footer>
    <!--footer end-->


  </div>
</template>

<script>
  import Constant from '../constant'

  export default {
    name: 'Login',
    data () {
      return {
        id:'',
        password:''
      }
    },
    methods: {
      login : function() {
        console.log('## login success ss')
        if (this.$store.dispatch(Constant.LOGIN, {id: this.id, password: this.password})) {
          console.log('## login success')
          this.$router.back()
        }
        else
          console.log('## login failed')
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Login.vue